import { AitCellData } from "./AitCellData";
import { AitHeaderCellData } from "./interface";

/**
 * Create a blank new cell.
 *
 * @param cellWidth - Width of the cell
 * @param blank - Blank value for the cell
 * @param columnId - The columnId to assign to the cell
 * @returns data for a new blank cell
 */
export const newCell = <T>(cellWidth: number, blank: T, columnId: string): AitCellData<T> => {
  const cell: AitCellData<T> = {
    aitid: crypto.randomUUID(),
    text: blank as T,
    comments: blank as T,
    colWidth: cellWidth,
    coreTrafficLight: "BlankNotEvaluated",
    columnId,
  };
  return cell;
};

/**
 * Create a blank new header cell.
 *
 * @param cellWidth - Width of the cell
 * @param blank - Blank value for the cell
 * @param columnId - The columnId to assign to the cell
 * @returns data for a new blank cell
 */
export const newHeaderCell = <T>(
  cellWidth: number,
  blank: T,
  columnId: string,
): AitHeaderCellData<T> => {
  const cell: AitHeaderCellData<T> = {
    aitid: crypto.randomUUID(),
    text: blank as T,
    comments: blank as T,
    rowSpan: 1,
    colSpan: 1,
    colWidth: cellWidth,
    coreTrafficLight: "BlankNotEvaluated",
    columnId,
  };
  return cell;
};
